// Generate code from clean architecture template

import { CourseTopicEntity } from '@/domains/course-topic/entities';
import {
  CourseTopicPayloadForm,
  QueryCourseTopicPayload,
  QueryCourseTopicsOutput,
} from '@/domains/course-topic/ports/payloads';
import { CourseTopicRepository } from '@/domains/course-topic/ports/repositories';
import { HttpClientAdapter } from '@/graphql/http-client-adapter';
import {
  CREATE_COURSE_TOPIC,
  DETAIL_COURSE_TOPIC,
  GET_COURSE_TOPIC_ITEMS,
  UPDATE_COURSE_TOPIC,
} from '../../graphql';

export class CourseTopicHttpRepository implements CourseTopicRepository {
  async getListCourseTopic(payload?: QueryCourseTopicPayload): Promise<QueryCourseTopicsOutput> {
    const response: QueryCourseTopicsOutput =
      await HttpClientAdapter.query<QueryCourseTopicsOutput>({
        query: GET_COURSE_TOPIC_ITEMS,
        dataKey: 'CourseTopic_getList',
        variables: { query: { sortBy: ['lastModifiedAt|desc', '_id|desc'], ...payload } },
      });
    return response;
  }

  async createCourseTopic(payload: CourseTopicPayloadForm): Promise<CourseTopicEntity> {
    const response = await HttpClientAdapter.mutate<CourseTopicEntity>({
      mutation: CREATE_COURSE_TOPIC,
      variables: { payload: payload },
    });
    return response;
  }

  async updateCourseTopic(payload: CourseTopicPayloadForm): Promise<CourseTopicEntity> {
    const response: CourseTopicEntity = await HttpClientAdapter.mutate<CourseTopicEntity>({
      mutation: UPDATE_COURSE_TOPIC,
      variables: { payload: payload },
    });
    return response;
  }

  async getDetailCourseTopic(payload: string): Promise<CourseTopicEntity> {
    const response: CourseTopicEntity = await HttpClientAdapter.query<CourseTopicEntity>({
      query: DETAIL_COURSE_TOPIC,
      dataKey: 'CourseTopic_getById',
      variables: { id: payload },
    });
    return response;
  }
}
